function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M93.803 25.802l15.566-15.56 3.26 3.26-15.567 15.56zM104.9 59.99h22v4.61h-22zM60.85 0h4.61v22.01h-4.61zM0 59.99h22.01v4.61H0zm14.27-46.501l3.26-3.26 15.563 15.563-3.26 3.26zM113 120.3l-2.31-18.84a1.72 1.72 0 00-1.69-1.52H95.5l-4.06-57.81H34.31l-4.06 57.81H17.92a1.74 1.74 0 00-1.72 1.52l-2.3 18.84a1.72 1.72 0 001.71 1.94h95.68a1.74 1.74 0 001.3-.58 1.77 1.77 0 00.41-1.36zm-95.44-1.52l1.88-15.39h88l1.88 15.39z",
  "data-name": "Layer 1",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 126.9 122.24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/crime.svg";
export { SvgComponent as ReactComponent };